module.exports = __webpack_public_path__ + "static/media/YM09_0.5cfc797a.jpg";